import { dispatchAction } from '@ardoq/rxbeach';
import {
  SetLoadedComponentsPayload,
  setComponentName,
  setComponentTypeName,
  setLoadedComponents,
  setAllComponentsSelected,
  toggleSingleComponentSelection,
  setStartQuery,
  setIsAdvancedSearch,
  UpdateViewpointBuilderAdvancedSearchQueryPayload,
  updateViewpointBuilderAdvancedSearchQuery,
  setStartSetFilter,
  setSelectedComponents,
  setSortDescriptor,
} from './actions';
import { QueryBuilderQuery, QueryBuilderSubquery } from '@ardoq/api-types';
import { resetAllSearchState } from 'search/actions';
import { SelectedComponent } from './types';
import type { SortDescriptor } from '@ardoq/table';

export const getComponentsSearchCommands = (namespace: string) => ({
  setComponentName: (componentName: string) =>
    dispatchAction(setComponentName(componentName), namespace),
  setComponentTypeName: (componentType: string) =>
    dispatchAction(setComponentTypeName(componentType), namespace),
  setAllComponentsSelected: (selected: boolean) =>
    dispatchAction(setAllComponentsSelected(selected), namespace),
  toggleSingleComponentSelection: (componentId: string) =>
    dispatchAction(toggleSingleComponentSelection(componentId), namespace),
  setLoadedComponents: (payload: SetLoadedComponentsPayload) =>
    dispatchAction(setLoadedComponents(payload), namespace),
  setSelectedComponents: (selectedComponents: SelectedComponent[]) =>
    dispatchAction(setSelectedComponents(selectedComponents), namespace),
  setTraversalStartQuery: (query: QueryBuilderQuery | null) =>
    dispatchAction(setStartQuery(query), namespace),
  setStartSetFilter: (filter: QueryBuilderSubquery | null) =>
    dispatchAction(setStartSetFilter(filter), namespace),
  setSortDescriptor: (descriptor: SortDescriptor | null) =>
    dispatchAction(setSortDescriptor(descriptor), namespace),
  setIsAdvancedSearch: (isAdvancedSearch: boolean) => {
    // resetAllSearchState clears both regular search and advanced search
    dispatchAction(resetAllSearchState(), namespace);
    dispatchAction(setIsAdvancedSearch(isAdvancedSearch), namespace);
  },
  viewpointBuilderAdvancedSearchQueryUpdated: (
    payload: UpdateViewpointBuilderAdvancedSearchQueryPayload
  ) => {
    dispatchAction(
      updateViewpointBuilderAdvancedSearchQuery(payload),
      namespace
    );
  },
});

export type ComponentsSearchCommands = ReturnType<
  typeof getComponentsSearchCommands
>;
